import { OfertaPropuestaMock } from './perfil-ofertas.model';

export type OrdenOfertas = '' | 'monto' | 'tasa' | 'plazo';

export function esTickSinTecho(tick: number, tope: number): boolean {
  return tick >= tope;
}

export function resolverFiltroTick(
  tick: number,
  filtroActual: number | null,
  topeSinTecho: number
): number | null {
  if (esTickSinTecho(tick, topeSinTecho)) {
    return null;
  }
  return filtroActual === tick ? null : tick;
}

export function filtrarOfertas(
  ofertas: OfertaPropuestaMock[],
  montoMaxMillones: number | null,
  tasaMax: number | null
): OfertaPropuestaMock[] {
  return ofertas.filter((oferta) => {
    const millones = oferta.monto / 1_000_000;
    const okMonto = montoMaxMillones == null || millones <= montoMaxMillones;
    const okTasa = tasaMax == null || oferta.tasa <= tasaMax;
    return okMonto && okTasa;
  });
}

export function ordenarOfertas(
  ofertas: OfertaPropuestaMock[],
  orden: OrdenOfertas
): OfertaPropuestaMock[] {
  if (!orden) {
    return [...ofertas];
  }
  return [...ofertas].sort((a, b) => {
    if (orden === 'monto') {
      return b.monto - a.monto;
    }
    if (orden === 'tasa') {
      return a.tasa - b.tasa;
    }
    return b.plazo - a.plazo;
  });
}

export const MAX_COMPARAR = 3;

export function toggleIdSeleccionado(
  ids: number[],
  id: number,
  max = MAX_COMPARAR
): number[] {
  if (ids.includes(id)) {
    return ids.filter((x) => x !== id);
  }
  if (ids.length >= max) {
    return ids;
  }
  return [...ids, id];
}

/** Recursos Bancóldex o línea Bancóldex. */
export function esOfertaBancoldex(oferta: OfertaPropuestaMock): boolean {
  const origen = (oferta.origenRecursos ?? '').toUpperCase();
  if (origen.includes('BANCOLDEX')) {
    return true;
  }
  if (oferta.idLineaBancoldex != null && oferta.idLineaBancoldex > 0) {
    return true;
  }
  return (oferta.linea ?? '').toUpperCase().includes('BANCOLDEX');
}

export function idsPresentesEnLista(
  ids: number[],
  ofertas: OfertaPropuestaMock[]
): number[] {
  const set = new Set(ofertas.map((o) => o.idPropuesta));
  return ids.filter((id) => set.has(id));
}
